import { useEffect, useState } from "react";
import {
	Navigate,
	Route,
	BrowserRouter as Router,
	Routes,
} from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import AdminDashboard from "./pages/Admin/Dashboard";

// Import pages
import AdminLogin from "./pages/Admin/Login";
import ClientProposal from "./pages/Client/ProposalView";
import { useAuthStore } from "./store/authStore";

function App() {
	const { isLoggedIn } = useAuthStore();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(false);
	}, []);

	if (loading) {
		return (
			<div className="min-h-screen bg-[#0B0F19] flex items-center justify-center">
				<div className="text-slate-300">Carregando...</div>
			</div>
		);
	}

	return (
		<ErrorBoundary>
			<Router>
				<Routes>
					{/* Root redirect */}
					<Route path="/" element={<Navigate to="/login" replace />} />

					{/* Admin Routes */}
					<Route path="/login" element={<AdminLogin />} />

					{/* Protected Admin Routes */}
					<Route
						path="/admin/*"
						element={
							isLoggedIn() ? (
								<AdminDashboard />
							) : (
								<Navigate to="/login" replace />
							)
						}
					/>

					{/* Client Routes */}
					<Route path="/proposta/:token" element={<ClientProposal />} />

					{/* Catch-all */}
					<Route path="*" element={<Navigate to="/login" replace />} />
				</Routes>
			</Router>
		</ErrorBoundary>
	);
}

export default App;
